var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-base-rail',{attrs:{"label":_vm.label,"variant":_vm.variant}},_vm._l((_vm.items),function(project){return _c(_vm.cardComponent,{key:project.id,tag:"component",attrs:{"project":project,"label":_vm.cardLabel},on:{"favorite-changed":function($event){return _vm.$emit('favorite-changed', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }